// extracted by mini-css-extract-plugin
module.exports = {"animated-video":"hero-video_animated-video__l5RCo","videoAnimation":"hero-video_videoAnimation__J4ZxQ"};